<template>
    <section>
        <div :style="`z-index: 250; position: fixed; right: 7%; top: ${screen_width >= 1265 ? '33px' : '100px'}; width: auto`">
            <v-alert
                v-model="notif.show"
                transition="scroll-x-reverse-transition"
                :type="notif.type"
                :color="notif.color"
                dismissible
            >
                {{ notif.msg }}
            </v-alert>
        </div>
        <h1 style="margin: 0 auto;">
            <v-icon
                v-if="screen_width > 390"
                x-large
                elevation="10"
                class="white--text"
                style="height: 50px; width: 50px; background-color: #009688; border-radius: 25px; margin-right: 2%;"
            >
                {{ mdiDoctor }}
            </v-icon>
            <span>Provider ACU Info</span>
        </h1>
        <v-card
            elevation="10"
            style="margin-top: 2%;"
            :loading="loading ? '#009688' : null"
        >
            <v-card-title>
                <v-autocomplete
                    v-model="msuCodes"
                    label="Hospital/Clinic/Group Name"
                    :items="items"
                    item-text="nameAndCode"
                    :disabled="loading && msuCodes !== null"
                    return-object
                    color="teal darken-1"
                    @change="handleChangeMsu()"
                >
                    <template #selection="data">
                        <v-chip
                            v-if="data.item.hosp_msu_code || data.item.group_id"
                            small
                            :color="data.item.type === 'SINGLE' ? 'teal' : 'blue'"
                            class="white--text"
                            style="font-weight: 700;"
                        >
                            {{ data.item.type === 'SINGLE' ? data.item.hosp_msu_code : data.item.group_id }}
                        </v-chip> {{ data.item.hosp_name }}
                    </template>
                    <template #item="data">
                        <v-chip
                            v-if="data.item.hosp_msu_code || data.item.group_id"
                            small
                            :color="data.item.type === 'SINGLE' ? 'teal' : 'blue'"
                            class="white--text"
                            style="font-weight: 700;"
                        >
                            {{ data.item.type === 'SINGLE' ? data.item.hosp_msu_code : data.item.group_id }}
                        </v-chip> &nbsp;{{ data.item.hosp_name }}
                    </template>
                </v-autocomplete>
            </v-card-title>
            <v-card-text>
                <div style="height: 38px;">
                    <!-- <span
                        v-if="itemsProviderAcu"
                        class="float-left"
                    >{{ displayPrefix }} {{ displayFname }} {{ displaySname }} {{ displaySuffix }}<br>{{ displayDesignation }}</span> -->
                    <v-btn
                        v-if="msuCodes !== null && itemsProviderAcu !== null"
                        class="float-right"
                        color="error"
                        width="100"
                        :disabled="loading"
                        @click="handleDeleteProviderAcuInfo"
                    >
                        <v-icon>{{ mdiPencil }}</v-icon>Delete
                    </v-btn>
                    <v-btn
                        v-if="itemsProviderAcu === null"
                        class="float-right"
                        color="success"
                        :disabled="msuCodes == null || loading"
                        width="100"
                        @click="handleAddProviderAcuInfo"
                    >
                        <v-icon>{{ mdiPlus }}</v-icon>Add
                    </v-btn>
                    <v-btn
                        v-else
                        class="float-right"
                        color="warning"
                        style="margin-right: 10px;"
                        width="100"
                        :disabled="loading"
                        @click="handleEditProviderAcuInfo"
                    >
                        <v-icon>{{ mdiPencil }}</v-icon>Edit
                    </v-btn>
                </div>
                <v-simple-table
                    dense
                    style="background-color: white; border-radius: 20px; padding: 10px 10px 0  10px; margin-top: 25px"
                >
                    <template #default>
                        <tbody>
                            <tr>
                                <td class="text-left">
                                    {{ msuCodes && msuCodes.type === 'SINGLE' ? 'MSU Code' : 'MSU Group ID' }}
                                </td>
                                <td>{{ displayMsuCode ? displayMsuCode : '-' }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    {{ msuCodes && msuCodes.type === 'SINGLE' ? 'Hospital/Clinic Name' : 'Group Name' }}
                                </td>
                                <td>{{ displayName ? displayName : '-' }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    Prefix
                                </td>
                                <td>{{ displayPrefix ? displayPrefix : '-' }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    First Name
                                </td>
                                <td>{{ displayFname ? displayFname : '-' }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    Last Name
                                </td>
                                <td>{{ displaySname ? displaySname : '-' }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    Suffix
                                </td>
                                <td>{{ displaySuffix ? displaySuffix : '-' }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    Designation
                                </td>
                                <td>{{ displayDesignation ? displayDesignation : '-' }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    ACU Contact Person
                                </td>
                                <td>{{ displayAcuContactPerson ? displayAcuContactPerson : '-' }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    ACU Contact No
                                </td>
                                <td>{{ displayAcuContactNo ? displayAcuContactNo : '-' }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    ACU Schedule
                                </td>
                                <td>{{ displayAcuSchedule ? displayAcuSchedule : '-' }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
        </v-card>
        <UpdateProviderAcuInfo
            :show="show.edit.status"
            :data="show.edit.value"
            :notif="notif"
            @closeDialog="handleCloseEditDialog"
        />
        <NewProviderAcuInfo
            :show="show.add.status"
            :data="show.add.value"
            :notif="notif"
            @closeDialog="handleCloseAddDialog"
        />
        <DeleteProviderAcuInfo
            :show="show.delete.status"
            :data="show.delete.value"
            :notif="notif"
            @closeDialog="handleCloseDeleteDialog"
        />
    </section>
</template>

<script>
import DeleteProviderAcuInfo from './DeleteProviderAcuInfo.vue'
import NewProviderAcuInfo from './NewProviderAcuInfo.vue'
import UpdateProviderAcuInfo from './UpdateProviderAcuInfo.vue'
import { mapActions, mapGetters } from 'vuex'
import {
    mdiDoctor,
    mdiPencil,
    mdiPlus
} from '@mdi/js'

export default {
    components: { UpdateProviderAcuInfo, NewProviderAcuInfo, DeleteProviderAcuInfo },
    data: ()=>({
        mdiDoctor,
        mdiPencil,
        mdiPlus,
        show: {
            add: {
                status: null,
                value: false
            },
            edit: {
                status: null,
                value: false
            },
            delete: {
                status: null,
                value: false
            }
        },
        items: [],
        itemsProviderAcu: null,
        headers: [
            { text: 'Designation', value: 'DESIGNATION' },
            { text: 'First Name', value: 'FNAME' },
            { text: 'MSU Code', value: 'MSU_CODE' },
            { text: 'Hospital/Clinic Name', value: 'NAME' },
            { text: 'Prefix', value: 'PREFIX' },
            { text: 'Last Name', value: 'SNAME' },
            { text: 'Suffix', value: 'SUFFIX' },
            { text: 'ACU Schedule', value: 'ACU_SCHEDULE' },
            { text: 'ACU Contact Person', value: 'ACU_CONTACT_PERSON' },
            { text: 'ACU Contact No', value: 'ACU_CLINIC_TELNO' }
        ],
        msuCodes: null,
        loading: false,
        notif: {
            show: false,
            type: 'success',
            msg: 'Done',
            color: 'success'
        },
        screen_width: document.documentElement.clientWidth + 9
    }),
    computed: {
        ...mapGetters(['viewProviderAcuInfoData', 'fetchAcuProvidersData']),
        displayMsuCode() {
            return this.itemsProviderAcu && this.itemsProviderAcu.MSU_CODE ? this.itemsProviderAcu.MSU_CODE : ''
        },
        displayName() {
            return this.itemsProviderAcu && this.itemsProviderAcu.NAME ? this.itemsProviderAcu.NAME : ''
        },
        displayDesignation() {
            return this.itemsProviderAcu && this.itemsProviderAcu.DESIGNATION ? this.itemsProviderAcu.DESIGNATION : ''
        },
        displayPrefix() {
            return this.itemsProviderAcu && this.itemsProviderAcu.PREFIX ? this.itemsProviderAcu.PREFIX : ''
        },
        displayFname() {
            return this.itemsProviderAcu && this.itemsProviderAcu.FNAME ? this.itemsProviderAcu.FNAME : ''
        },
        displaySname() {
            return this.itemsProviderAcu && this.itemsProviderAcu.SNAME ? this.itemsProviderAcu.SNAME : ''
        },
        displaySuffix() {
            return this.itemsProviderAcu && this.itemsProviderAcu.SUFFIX ? this.itemsProviderAcu.SUFFIX : ''
        },
        displayAcuSchedule() {
            return this.itemsProviderAcu && this.itemsProviderAcu.ACU_SCHEDULE ? this.itemsProviderAcu.ACU_SCHEDULE : ''
        },
        displayAcuContactPerson() {
            return this.itemsProviderAcu && this.itemsProviderAcu.ACU_CONTACT_PERSON ? this.itemsProviderAcu.ACU_CONTACT_PERSON : ''
        },
        displayAcuContactNo() {
            return this.itemsProviderAcu && this.itemsProviderAcu.ACU_CLINIC_TELNO ? this.itemsProviderAcu.ACU_CLINIC_TELNO : ''
        }

    },
    watch: {
        notif: {
            handler(newVal) {
                if (newVal.show) {
                    if (newVal.timeout !== 0) {
                        setTimeout(() => {
                            this.notif.show = false
                        }, newVal.timeout)
                    }
                }
            },
            deep: true
        },
        viewProviderAcuInfoData(newVal) {
            if (newVal) {
                if (newVal.status === 200) {
                    this.itemsProviderAcu = newVal.data
                } else {
                    this.itemsProviderAcu = null
                }
            } else {
                this.itemsProviderAcu = null
            }
            this.loading = false
        },
        fetchAcuProvidersData(newVal) {
            if (newVal) {
                if (newVal.status === 200 && newVal.data && newVal.data.length > 0) {
                    this.items = newVal.data.map(item => ({ ...item, nameAndCode: `${item.type === 'SINGLE' ? item.hosp_msu_code : item.group_id} ${item.hosp_name}` }))
                }
            }
            this.loading = false
        }
    },
    mounted() {
        this.loading = true
        // this.getCsrfToken()
        this.fetchAcuProviders()
    },
    methods: {
        ...mapActions(['getCsrfToken', 'viewProviderAcuInfo', 'fetchAcuProviders']),
        handleDeleteProviderAcuInfo() {
            this.show.delete.value = this.itemsProviderAcu
            this.show.delete.status = true
        },
        handleCloseDeleteDialog(isDeleteSuccess) {
            this.show.delete.value = this.msuCodes
            this.show.delete.status = false
            this.itemsProviderAcu = isDeleteSuccess ? null : this.itemsProviderAcu
        },
        handleAddProviderAcuInfo() {
            this.show.add.value = this.msuCodes
            this.show.add.status = true
        },
        handleCloseAddDialog() {
            this.show.add.value = this.msuCodes
            this.show.add.status = false
        },
        handleEditProviderAcuInfo() {
            this.show.edit.value = { ...this.itemsProviderAcu, ...this.msuCodes }
            this.show.edit.status = true
        },
        handleCloseEditDialog() {
            this.show.edit.value = { ...this.itemsProviderAcu, ...this.msuCodes }
            this.show.edit.status = false
        },
        handleChangeMsu() {
            if (this.msuCodes) {
                this.loading = true
                this.viewProviderAcuInfo({ MSU_C: this.msuCodes.type === 'SINGLE' ? this.msuCodes.hosp_msu_code : this.msuCodes.group_id })
            }
        }
    }
}
</script>

<style scoped>
h1 {
    font-size: 25px;
    padding: 10px;
    border-bottom: 1px solid #bbb;
}
</style>
